import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {TrustiiService} from './trustii.service';
import {Observable, of} from 'rxjs';
import {map, catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HomeResolveService implements Resolve<any> {
  constructor(private trustiiService: TrustiiService) {
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return this.trustiiService.autoLogin().pipe(map(data => data.data), catchError(err => of(null)));
  }
}

